const LOCAL_STORAGE_PERSIST_KEYS = ['emoji-mart.frequently', 'emoji-mart.last'];

export default LOCAL_STORAGE_PERSIST_KEYS;
